<template>
    <form ref="form" class="form-enquiry needs-validations">
        <template v-if="showMessage">
            <div v-if="message" class="alert alert-success" v-html="message">
            </div>
            <div v-else-if="error" class="alert alert-danger" v-html="error"></div>
            <div v-else-if="config.template == 'FileDownloadForm'">
                <p v-html="config.content"></p>
            </div>
            <div v-else>
                <p v-html="$t('site.form-helptext')"></p>
            </div>
        </template>
        <fieldset>
            <div class="row">
                <template v-for="field in _.get(formConfig, 'fields', [])">
                    <div v-if="field.data_type == 'input-text'" :class="[field.fullwidth ? 'col-12' : 'col-md-6']">
                        <div class="form-group field">
                            <input v-model="formData[field.name]"
                                   :id="field.name + '_' + _.get(formConfig, 'id', 'form')"
                                   :name="field.name"
                                   :placeholder="field.title"
                                   :required="!!field.required"
                                   class="form-control req"
                                   type="text"
                                   tabindex="1">
                            <label :for="field.name + '_' + _.get(formConfig, 'id', 'form')" class="">{{ field.title }}</label>
                        </div>
                    </div>
                    <div v-if="field.data_type == 'input-email'" :class="[field.fullwidth ? 'col-12' : 'col-md-6']">
                        <div class="form-group field">
                            <input v-model="formData[field.name]"
                                   :id="field.name + '_' + _.get(formConfig, 'id', 'form')"
                                   :name="field.name"
                                   :placeholder="field.title"
                                   :required="!!field.required"
                                   class="form-control req"
                                   type="email"
                                   tabindex="1">
                            <label :for="field.name + '_' + _.get(formConfig, 'id', 'form')" class="">{{ field.title }}</label>
                        </div>
                    </div>
                    <div v-if="field.data_type == 'selectbox'" class="col-12">
                        <div class="form-group">
                            <select v-model="formData[field.name]"
                                    :id="field.name + '_' + _.get(formConfig, 'id', 'form')"
                                    :name="field.name"
                                    :placeholder="field.title"
                                    :required="!!field.required"
                                    :data-title="field.title"
                                    data-width="100%"
                                    data-size="8"
                                    data-style="btn-select"
                                    class="selectpicker"
                                    tabindex="1">
                                    <option v-for="option in getSelectValues(field)" :value="option.id" :key="option.id">
                                    {{ option.name }}
                                </option>
                                <!-- <option v-for="option in field.values" :value="option">{{ option }}</option> -->
                            </select>
                        </div>
                    </div>
                    <div v-if="field.data_type == 'selectbox-search'" class="col-6">
                        <div class="form-group">
                            <select v-model="formData[field.name]"
                                    :id="field.name + '_' + _.get(formConfig, 'id', 'form')"
                                    :name="field.name"
                                    :placeholder="field.title"
                                    :required="!!field.required"
                                    :data-title="field.title"
                                    data-width="100%"
                                    data-size="8"
                                    data-style="btn-select"
                                    data-live-search="true"
                                    class="selectpicker"
                                    tabindex="1">
                                <option v-for="option in field.values" :value="option" >{{ option }}</option>
                            </select>
                        </div>
                    </div>
                    <div v-if="field.data_type == 'selectbox-countries'" class="col-12">
                        <div class="form-group">
                            <select v-model="formData[field.name]"
                                    :id="field.name + '_' + _.get(formConfig, 'id', 'form')"
                                    :name="field.name"
                                    :placeholder="field.title"
                                    :required="!!field.required"
                                    :data-title="field.title"
                                    data-width="100%"
                                    data-size="8"
                                    data-style="btn-select"
                                    data-live-search="true"
                                    class="selectpicker"
                                    tabindex="1">

                                    
                                 <option v-for="(option, index) in countries" :value="option" :key="index">
                                    {{ option }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div v-if="field.data_type == 'textarea'" class="col-12">
                        <div class="form-group">
                            <label class="sr-only" :for="field.name + '_' + _.get(formConfig, 'id', 'form')">{{ field.title }}</label>
                            <textarea v-model="formData[field.name]"
                                :name="field.name"
                                :id="field.name + '_' + _.get(formConfig, 'id', 'form')"
                                :placeholder="field.title"
                                :required="!!field.required"
                                class="form-control"
                                rows="8"
                                tabindex="1"
                                ></textarea>
                        </div>
                    </div>
                </template>
            </div>
        </fieldset>

        <div class="form-group">
            <button disabled :class="['btn', 'btn-yellow', 'disabled', formLoading ? btnClass : 'd-none']"
                >{{ $t('site.form-loading') }}</button>
            <button :data-sitekey="getRecaptchaKey()"
                class="btn btn-yellow"
                :class="[formLoading ? 'd-none' : btnClass]"
                ref="form-btn"
                data-theme="light"
                type="button"
                >{{ btnLabel }}</button>
        </div>
    </form>
</template>

<script>
import jsonp from 'jsonp';
import VueRecaptcha from 'vue-recaptcha';
import UtilsMixin from '../UtilsMixin';

export default{
    data() {
        let formData = {};
        // restore previous form data
        // formData = JSON.parse(window.localStorage.getItem('formData') || '{}');

        return {

            formHandler: 'submitForm' + Math.floor(Math.random() * 1000000),
            formData,
            localLoading: false,
            message: '',
            error: '',
            countries: [],
            countriesLoaded: false,
        }
    },

    props: ['initialData', 'config', 'loading'],

    components: {
        VueRecaptcha,
    },

    mixins: [UtilsMixin],

    created() {
        _.chain(this.formConfig)
            .get('fields', [])
            .map(field => {
                let value = _.get(this.initialData, field.name, '');
                this.$set(this.formData, field.name, _.get(this.formData, field.name, ''))
            })
            .value();

        window[this.formHandler] = this.submitForm;
        this.loadCountriesIfNeeded();
    },

    mounted() {
        this.registerRecaptcha();

        // $('.selectpicker').selectpicker('toggle');
        this.$nextTick(() => {
            $('bootstrap-select.show').on('keydown', function (e) {
                if (e.keyCode == 13) { // Enter
                    var elm = $(this);

                    var selVal = $('.selectpicker option').filter(function () {
                        return $(this).text() == elm.text();
                    }).val();
                    $('.selectpicker').selectpicker('val', selVal);

                    return;
                }
                if (e.keyCode == 38) { // Up
                    var previousEle = $(this).prev();
                    if (previousEle.length == 0) {
                        previousEle = $(this).nextAll().last();
                    }
                    var selVal = $('.selectpicker option').filter(function () {
                        return $(this).text() == previousEle.text();
                    }).val();
                    $('.selectpicker').selectpicker('val', selVal);

                    return;
                }
                if (e.keyCode == 40) { // Down
                    var nextEle = $(this).next();
                    if (nextEle.length == 0) {
                        nextEle = $(this).prevAll().last();
                    }
                    var selVal = $('.selectpicker option').filter(function () {
                        return $(this).text() == nextEle.text();
                    }).val();
                    $('.selectpicker').selectpicker('val', selVal);

                    return;
                }
            });
        })
    },

    computed: {
        formConfig() {
            return _.get(this, 'config', {});
        },

        formLoading() {
            return this.localLoading || this.loading;
        },

        btnLabel() {
            return _.get(this.formConfig, 'btnLabel', this.$t('site.submit'));
        },

        btnClass() {
            return _.get(this.formConfig, 'btnClass', '');
        },

        showMessage() {
            return _.get(this.formConfig, 'showMessage', true);
        },

        locale() {
            return _.get(this.formConfig, 'locale', 'en');
        },

        currentFile() {
            return _.get(this.formConfig, 'file', {});
        },
    },

    methods: {

        getSelectValues(field) {
            return this.formatValues(_.isArray(field.values) ? field.values : _.split(field.values, '\n'));
        },


        formatValues(values) {
            return values.map((val) => {
                if (!_.has(val.id)) {
                    return {
                        id: val,
                        name: val,
                    }
                }
                return val;
            });
        },


        randomKey() {
            return String(Math.random(100000));
        },

        submitForm(token) {
            let $form = $(this.$refs['form']);
            $form.addClass('was-validated');

            let $btn = $(this.$refs['form-btn']);

            if ($form[0].checkValidity()) {
                this.localLoading = true;
                let endpoint = _.get(this.formConfig, 'ajax', 'customer/post-form');
                let action = _.get(this.formConfig, 'action', 'SENDENQUIRY');
                window.localStorage.setItem('formData', JSON.stringify(this.formData));

                return this.api.postData(`/../${endpoint}`, {}, _.assign({},
                    this.initialData,
                    this.formConfig,
                    this.formData, {
                    action,
                    form_id: this.config.id,
                    ['g-recaptcha-response']: token,
                }))
                .then(async res => {

                    // if file is set, download it
                    await this.handleFileDownload(res, this.currentFile);

                    this.handleFormInput(res);
                    this.$emit('input', res);
                    this.sharpspringPush(
                        _.get(this.formConfig, 'sharpspring_url'),
                        _.get(this.formConfig, 'sharpspring_endpoint'),
                    )
                    
                    // reset form data
                    $form.removeClass('was-validated');
                    _.chain(this.formConfig)
                        .get('fields', [])
                        .map(field => {
                            let value = _.get(this.initialData, field.name, '');
                            this.$set(this.formData, field.name, '')
                        })
                        .value();

                })
                .catch(err => {
                    this.handleFormError(err);
                    this.$emit('error', err);
                })
                .finally(() => {
                    this.localLoading = false;
                })
            }
        },

        getRecaptchaKey() {
            return window.env.RECAPTCHA_SITE_KEY;
        },

        registerRecaptcha() {

            if (_.get(grecaptcha, 'render')) {
                this.initRecaptchaButton();
            }
            window.addEventListener('recaptcha-init', () => {
                this.initRecaptchaButton();
            })
        },

        initRecaptchaButton() {
            grecaptcha.render(this.$refs['form-btn'], {
                sitekey: this.getRecaptchaKey(),
                callback: this.submitForm,
            });
        },

        handleFormInput(res) {
            this.localLoading = false;

            const successMessage = _.get(this.config, 'success_message', false);

            if (successMessage) {
                this.message = `<p class="mb-0">${successMessage}</p>`;
            } else {
                this.message = `<p class="mb-0">${this.$t('site.form-success')}</p> ${this.$t('site.form-adwords')}`;
            }

            window.localStorage.setItem('resource-form-data', JSON.stringify(res.data));
        },

        handleFormError(err) {
            this.localLoading = false;
            let res = _.get(err, 'response.data');
            let errors = _.chain(res).get('errors', [])
                .values()
                .flatMap(v => `<li>${v}</li>`)
                .join()
                .value();

            if (res) {
                this.error = `
                    <p>${res.message}</p>
                    <ul>${errors}</ul>
                `;
            } else {
                this.error = `${this.$t('site.form-error')}`;
            }
        },

        async handleFileDownload(res, file) {
            return new Promise(async (resolve, reject) => {
                try {
                    if (!file?.id) {
                        resolve(res);
                        return;
                    }

                    const response = await this.api.postData('/downloads', {}, {
                        token_id: res.id,
                        file: _.get(file, 'id')
                    });

                    let downloadLink = _.filePath(file, true);
                    window.open(downloadLink, '_self');
                    resolve(response);
                } catch (error) {
                    reject(error);
                }
            })
        },


        sharpspringPush(url, endpoint) {
            let ssTracking = this.getCookie('__ss_tk');
            let params = new URLSearchParams(_.assign({}, this.initialData, this.formData, { trackingid__sb: ssTracking, locale: this.locale }));

            return jsonp(`${url}${endpoint}/jsonp/?${params.toString()}`, null, (err, data) => {
                console.log(err, data)
            })
        },

        getCookie(name) {
            var value = "; " + document.cookie;
            var parts = value.split("; " + name + "=");
            if (parts.length == 2) return parts.pop().split(";").shift();
        },

        loadCountriesIfNeeded() {
            // Only load if there's a country selectbox field and we haven't loaded yet
            const hasCountryField = _.get(this.formConfig, 'fields', [])
                .some(field => field.data_type === 'selectbox-countries');
            
            if (hasCountryField && !this.countriesLoaded) {
                this.loadCountries();
            }
        },

        loadCountries() {
            if (this.countriesLoaded) {
                return;
            }

            this.countriesLoaded = true;
            this.api.getData('/countries')
                .then(res => {
                    this.countries = res.data || res;
                })
                .catch(err => {
                    console.error('Failed to load countries:', err);
                    this.countriesLoaded = false; // Reset flag on error so it can retry
                });
        },
    },
}
</script>

<style scoped>

</style>
